import React from 'react';

import { clsx } from 'clsx';

type ParagraphProps = React.PropsWithChildren & {
  className?: string;
};

const Paragraph = (props: ParagraphProps) => {
  return <p className={clsx(props.className, 'mb-4 text-base')}>{props.children}</p>;
};

export default Paragraph;
